import { BiCodeAlt } from 'react-icons/bi';
import { GiAutoRepair } from 'react-icons/gi';
import { MdPayment } from 'react-icons/md';
import { AiFillGithub } from 'react-icons/ai';
import { DiCodeigniter } from 'react-icons/di';
import { DiYii } from 'react-icons/di';
import { DiLaravel } from 'react-icons/di';

export const SkillSet=[
    {
        id: 1,
        name: "PHP",
        imgsrc: "images/php.png"
    },
    {
        id: 41,
        name: "Laravel",
        imgsrc: "images/laravel.png"
    },
    {
        id: 42,
        name: "Codeigniter",
        imgsrc: "images/codeigniter.png"
    },
    {
        id: 2,
        name: "Yii",
        imgsrc: "images/yii.png"
    },
    {
        id: 3,
        name: "HTML 5",
        imgsrc: "images/HTML5.png"
    },
    {
        id: 4,
        name: "CSS 3",
        imgsrc: "images/CSS3.png"
    },
    {
        id: 5,
        name: "Javascript",
        imgsrc: "images/javascript.png"
    },
    {
        id: 6,
        name: "Bootstrap",
        imgsrc: "images/Bootstrap.png"
    },
    {
        id: 7,
        name: "ReactJs",
        imgsrc: "images/React.png"
    },
    {
        id: 8,
        name: "Material-ui",
        imgsrc: "images/Material-ui.png"
    },
    {
        id: 9,
        name: "Sass",
        imgsrc: "images/SASS.png"
    },
    {
        id: 10,
        name: "Vue",
        imgsrc: "images/vuejs.png"
    },
    {
        id: 11,
        name: "Express",
        imgsrc: "images/express.png"
    },
    {
        id: 12,
        name: "Next Js",
        imgsrc: "images/Nextjs-logo.svg"
    },
    {
        id: 13,
        name: "MongoDB",
        imgsrc: "images/mongodb.png"
    },
    {
        id: 14,
        name: "MySQL",
        imgsrc: "images/mysql.png"
    },
    {
        id: 15,
        name: "Github",
        imgsrc: "images/github.png"
    },
    {
        id: 16,
        name: "Firebase",
        imgsrc: "images/firebase.png"
    },
    {
        id: 17,
        name: "Netlify",
        imgsrc: "images/netlify.png"
    },
    {
        id: 18,
        name: "Illustrator",
        imgsrc: "images/Illustrator.png"
    },

    {
        id: 19,
        name: "Photoshop",
        imgsrc: "images/Photoshop.png"
    },
    {
        id: 20,
        name: "Canva",
        imgsrc: "images/canva.png"
    },

]

export const ProjImg = [
    {
        id: 1,
        name: "Illusions Theatre",
        category: "php",
        imgsrc: "projectImg/react/booking.jpg",
        href: "https://illusionskohsamui.com/"
    },
    {
        id: 12,
        name: "Induslaw",
        category: "php",
        imgsrc: "projectImg/php/induslaw.jpg",
        href: "https://induslaw.com/"
    },
    {
        id: 13,
        name: "TheBotanicalSource",
        category: "php",
        imgsrc: "projectImg/php/thebotanicalsource.jpg",
        href: "https://thebotanicalsource.com/"
    },
    {
        id: 14,
        name: "Sport Fan Stickers",
        category: "php",
        imgsrc: "projectImg/php/sportfanstickers.jpg",
        href: "https://sportfanstickers.com/"
    },
    {
        id: 15,
        name: "CareesInGlass.com",
        category: "php",
        imgsrc: "projectImg/php/cing.jpg",
        href: "https://careersinglass.com/"
    },
    {
        id: 16,
        name: "One Click Immigration",
        category: "php",
        imgsrc: "projectImg/php/oci.jpg",
        href: "https://oneclickimmigration.com/"
    },
    {
        id: 17,
        name: "Huna Care",
        category: "php",
        imgsrc: "projectImg/php/huna.jpg",
        href: "https://huna.care/"
    },
    {
        id: 2,
        name: "Homey - A Better Smart Home",
        category: "php",
        imgsrc: "projectImg/react/homey.jpg",
        href: "https://homey.app/"
    },
    {
        id: 3,
        name: "HubSpot Certified",
        category: "API",
        imgsrc: "projectImg/react/HS_CERTIFICATE.png",
        href: "https://developers.hubspot.com/docs/api/overview"
    },
    {
        id: 4,
        name: "Clay By MG",
        category: "react",
        imgsrc: "projectImg/react/claybymg.jpg",
        href: "https://www.claybymg.com"
    },
    {
        id: 5,
        name: "MEDii",
        category: "react",
        imgsrc: "projectImg/react/medii.jpg",
        href: "https://medii-testing.clients.webcider.dev"
    },
    {
        id: 6,
        name: "T-Shirt Design",
        category: "react",
        imgsrc: "projectImg/react/tshirt.jpg",
        href: "https://t-shirt-design-5818e.web.app/"
    },
    {
        id: 7,
        name: "Google Clone",
        category: "react",
        imgsrc: "projectImg/react/google.jpg",
        href: "https://clone-61cf3.web.app/"
    },
    {
        id: 8,
        name: "Slack Clone",
        category: "react",
        imgsrc: "projectImg/react/slack.jpg",
        href: "https://slackclone-6f0e0.web.app/"
    },
    {
        id: 8,
        name: "Amazon Clone",
        category: "react",
        imgsrc: "projectImg/react/amazon.jpg",
        href: "https://amazon-clone-928j.vercel.app/"
    },
    {
        id: 18,
        name: "Journey Genie",
        category: "react",
        imgsrc: "projectImg/react/journey.jpg",
        href: "https://dev-journey-genie.netlify.app/"
    },
    {
        id: 19,
        name: "Clouditix",
        category: "react",
        imgsrc: "projectImg/react/clouditix.jpg",
        href: "https://clouditix.com/"
    },
    {
        id: 20,
        name: "WhiskeyTrove",
        category: "react",
        imgsrc: "projectImg/react/whiskey.jpg",
        href: "https://www.whiskeytrove.com/"
    },
    {
        id: 21,
        name: "Stashem",
        category: "react",
        imgsrc: "projectImg/react/stashem.jpg",
        href: "https://www.stashem.com/"
    },
    ]
export const Experience=[
    
    {
        id: 1,
        date: "Mar 2022 - Present",
        name: "IT Support Manager (Part-time)",
        company: "ETN AMERICA",
        desc: ["Monitoring Ringba","API Integration"]
    },
    {
        id: 2,
        date: "Jan 2023 - Present",
        name: "CTO",
        company: "SoftX Solution",
        desc: ["Cheif Technical Officer"]
    },
    {
        id: 3,
        date: "Mar 2021 - Present",
        name: "Top Rated Plus Freelancer",
        company: "Upwork Marketplace",
        desc: ["Full-stack Web Developer", "API Expert", "CRM Development"]
    },
    {
        id: 4,
        date: "Jan 2018 - June 2021",
        name: "Software Engineer",
        company: "Tatvasoft",
        desc: ["PHP Developer"]
    },
    
]
export const Education=[

    {
        id: 1,
        date: "Aug 2014 - May 2018",
        name: "B.E. (Computer Engineering)",
        company: "GEC Bhavnagar",
        desc: "B.E. Degree in Computer Engineering at Government Engineering College, Bhavnagar, Gujarat"
    },
    {
        id: 2,
        date: "Aug 2013 - Apr 2014",
        name: "11th & 12th",
        company: "S.H.GAJERA HIGHER SECONDARY SCHOOL",
        desc: "Completed 11-12th"
    },
    {
        id: 3,
        date: "2012",
        name: "10TH",
        company: "M.D.Patel Highschool",
        desc: ""
    },
    
]
export const Services=[
    {
        id: 1,
         icon: <BiCodeAlt />,
         name: "Web Development",
         desc: "",
    },
    {
         id: 2,
         icon: <DiLaravel />,
         name: "Laravel",
         desc: "",
    },
    {
         id: 3,
         icon: <DiYii />,
         name: "Yii",
         desc: "",
    },
    {
        id: 11,
         icon: <DiCodeigniter />,
         name: "Codeigniter",
         desc: "",
    },
    {   id: 12,
        icon: <GiAutoRepair/>,
        name: "API Integration",
        desc: "",
    },
    {   id: 13,
        icon: <MdPayment/>,
        name: "Payment Gateway",
        desc: "",
    },
    {   id: 14,
        icon: <AiFillGithub/>,
        name: "Git",
        desc: "",
    }
]